// extracted by mini-css-extract-plugin
module.exports = {"block":"SectionBlock_block__NVd5m","title":"SectionBlock_title__2gWn4","body":"SectionBlock_body__22Br-"};